import React from 'react';
import ReactGA from "react-ga4";
import usePageTracking from "./hooks/usePageTracking"; 
import { Routes, Route, useLocation } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import ProjectsPage from './pages/ProjectsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import HomePage from './pages/HomePage';
import AssignmentPage from './pages/AssignmentPage';

ReactGA.initialize("G-4CQPX97ZSC");

export default function App() {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  
   usePageTracking(); // 👈 tracks route changes


  return (
    <div className="app-container">
      {!isLanding && <Navbar />}
      
      <main className="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/assignments" element={<AssignmentPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/home" element={<HomePage />} />
        </Routes>
      </main>

      {!isLanding && <Footer />}
    </div>
  );
}
